"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var defaultStyles = function (theme) {
    return {
        root: {
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            overflow: "hidden"
        }
    };
};
var StyleConfig = {
    defaultStyles: defaultStyles
};
exports.StyleConfig = StyleConfig;
var getStyles = utilities_1.memoizeFunction(function (theme, customStyles) {
    return styling_1.concatStyleSets(StyleConfig.defaultStyles(theme || styling_1.getTheme()), customStyles);
});
exports.getStyles = getStyles;
